/**
 * Identity session tenant — D6b hygiene.
 * Invite + identity-agent execute use the signed-in tenant.
 * Never invent `dev` when the session has no tenant.
 */

export function normalizeSessionTenant(value: unknown): string | null {
  if (value == null) return null;
  const tenant = String(value).trim();
  return tenant || null;
}

export function resolveIdentitySessionTenant(session: {
  selectedTenant?: string | null;
  tokenTenant?: string | null;
}): string | null {
  return (
    normalizeSessionTenant(session.selectedTenant) ||
    normalizeSessionTenant(session.tokenTenant)
  );
}
